import { FC, useMemo } from 'react';
import { CgCheckO, CgCloseO, CgTime } from 'react-icons/cg';
import { Box, Text } from '@chakra-ui/react';

import { ContentElementProps } from '../ContentElement.component';

export const Check: FC<ContentElementProps> = ({ element, ...props }) => {
  const { value } = element;
  const color = useMemo(() => {
    if (value === 'ok') return 'green.500';
    if (value === 'failed') return 'red.500';
    return 'gray.700';
  }, [value]);
  const node = (
    <>
      <Text color="gray.700" fontSize="12px" textTransform="uppercase">
        {element.name}
      </Text>
      <Box color={color} whiteSpace="nowrap">
        <Text display="inline-block">
          {value === 'ok' && <CgCheckO />}
          {value === 'failed' && <CgCloseO />}
          {(value === 'unchecked' || !value) && <CgTime />}
        </Text>
        <Text as="span" ml={1} textTransform="uppercase">
          {value || 'Unchecked'}
        </Text>
      </Box>
    </>
  );

  return <Box {...props}>{node}</Box>;
};
